export { default } from './Account';
// The props contract lives in shared/lib/types now — every brand's Layouts.Account is
// fed by the same builder. Re-exported here so existing importers keep working.
export type { AccountLayoutProps } from '@v2/shared/lib/types';
